import Vue from 'vue'
import ActionEdit from './ActionEdit'
import ActionView from './ActionView'
import ActionDelete from './ActionDelete'
import ActionMessage from './ActionMessage'
import ActionPush from './ActionPush'
import ActionUpgrade from './ActionUpgrade'

export default {
  install(){
    Vue.component("ActionEdit",ActionEdit)
    Vue.component("ActionView",ActionView)
    Vue.component("ActionDelete",ActionDelete)
    Vue.component("ActionMessage",ActionMessage)
    Vue.component("ActionPush",ActionPush)
    Vue.component("ActionUpgrade",ActionUpgrade)
  }
}



// WEBPACK FOOTER //
// ./src/components/table/TableAction.js